import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import { releaseTagRegex } from "./sentry-utils";

export function sentrySetup() {
  const releaseName = import.meta.env.VITE_RELEASE_NAME;
  const sentryEnabled =
    window["runtime"].VITE_SENTRY_ENABLED && window["runtime"].VITE_SENTRY_ENABLED.toLowerCase() === "true";

  if (sentryEnabled) {
    Sentry.init({
      release: releaseName,
      dsn: "https://8f6f71bf9aa4442f98684f853e9f79fb@o4505704964554752.ingest.sentry.io/4505704974057472",
      denyUrls: [releaseTagRegex],
      integrations: [
        Sentry.replayIntegration({
          networkDetailAllowUrls: [""],
          networkRequestHeaders: ["Request-ID"],
        }),
        Sentry.captureConsoleIntegration({ levels: ["error"] }),
        Sentry.httpClientIntegration(),
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
      tracesSampleRate: 0.4,
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: [
        "Received status code 403",
        "Request failed with status code 403",
        "Canceled: Canceled", // https://github.com/microsoft/monaco-editor/issues?q=is%3Aissue+Uncaught+%28in+promise%29+Canceled%3A+Canceled
        "Non-Error promise rejection captured with value: Object Not Found Matching Id:", // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062
      ],
      beforeSend(event) {
        if (event.user && event.user.email && event.user.email === "pinger@switchboard.engineering") {
          return null;
        }

        return event;
      },
      beforeSendTransaction(transaction) {
        if (transaction.user && transaction.user.email && transaction.user.email === "pinger@switchboard.engineering") {
          return null;
        }
        return transaction;
      },

      attachStacktrace: true, // Also log stacktrace when a custom message is sent to Sentry
    });
  }
}
